/** @jsxImportSource @emotion/react */
import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import { PanelTableInfo, PanelTableInfoProps } from "./PanelTableInfo";

export const WorkflowEditorPageTableInfo = () => {
  const tables = useWorkflowEditorContext((s) => {
    return s.tableInfo.map<PanelTableInfoProps["tables"][number]>((table) => {
      const overrides = s.tableInfoOverrides[table.id];
      return {
        id: table.id,
        stepName: overrides.name,
        tableVersion: overrides.toolVersion,
        toolName: table.toolName,
      };
    });
  });

  return <PanelTableInfo tables={tables} />;
};
